import { render } from "./TicketsPSC27.vue?vue&type=template&id=b9b4593c"
import script from "./TicketsPSC27.vue?vue&type=script&lang=js"
export * from "./TicketsPSC27.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__